<script lang="ts">
  // *** This file is part of DbGate Premium ***

  import { ProcessedChart } from 'dbgate-datalib';
  import ChartCore from './ChartCore.svelte';
  import { currentThemeDefinition } from '../stores';
  import ErrorInfo from '../elements/ErrorInfo.svelte';
  import { ChartDataCreator } from './chartDataCreator';

  export let chart: ProcessedChart;

  let clientWidth;
  let clientHeight;

  $: chartData = chart?.errorMessage ? null : new ChartDataCreator(chart, $currentThemeDefinition, false);
  $: chartDataExport = chart?.errorMessage ? null : new ChartDataCreator(chart, $currentThemeDefinition, true);

  // $: console.log('CHART', chart);
  const CHART_TYPE_MAP = {
    timeline: 'line',
  };
</script>

{#if chart?.errorMessage}
  <ErrorInfo message={chart.errorMessage} alignTop />
{:else if chartData && chartDataExport}
  <div class="wrapper" bind:clientWidth bind:clientHeight>
    {#key `${JSON.stringify(chart.definition)}|${clientWidth}|${clientHeight}`}
      <ChartCore
        width={clientWidth}
        height={clientHeight}
        data={chartData.data}
        type={CHART_TYPE_MAP[chart.definition.chartType] || chart.definition.chartType}
        title={'Test'}
        options={chartData.options}
        plugins={chartData.plugins}
        exportOptions={chartDataExport.options}
        exportPlugins={chartDataExport.plugins}
      />
    {/key}
  </div>
{/if}

<style>
  .wrapper {
    flex: 1;
    overflow: hidden;
  }
</style>
